/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import {
    object, shape, string, func,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ReactMarkdown from 'react-markdown';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import transformRenderer from '../../../../../helpers/markdown/characterTransformer';
import ResponsiveImage from '../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';
import { trackEvent as track } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) => ({
    contaniner: {
        display: 'flex',
        alignItems: 'center',
        margin: '0px 0px 10px 0px',
        minHeight: '160px',
        background: theme.palette?.cms?.activeButtonColor || '#E8F1ED',
    },
    heading: {
        fontSize: '20px',
        fontWeight: 'normal',
        lineHeight: '24px',
        marginBottom: '10px',
    },

    imageContainer: {
        width: 'auto',
        margin: '0px 0px 0px 40px',
        [theme.breakpoints.down('xs')]: {
            margin: '0px 0px 0px 25px',
        },
    },
    image: {
        maxWidth: '90px',
        minHeight: '106px',
        border: `4px solid ${theme.palette.cms?.white || '#ffffff'}`,
    },
    description: {
        marginLeft: '25px',
    },
    messageWrapper: {
        '& p': {
            fontSize: '13px',
            margin: '0px',
        },
        [theme.breakpoints.down('xs')]: {
            '& p': {
                fontSize: '11px',
            },
        },
    },
    options: {
        fontSize: '13px',
        fontWeight: '400',
        textDecoration: 'underline',
        letterSpacing: '1px',
        margin: 0,
        cursor: 'pointer',
        marginTop: '10px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '11px',
        },
    },
});

const AddonV2 = ({
    classes,
    copy,
    openModal,
    image,
    heading,
    trackEvent,
    selectedSku,
}) => {
    useEffect(() => {
        setTimeout(() => {
            trackEvent({
                eventCategory: 'Test Impression',
                eventAction: 'PDP Addon V2',
                eventLabel: selectedSku.name,
                nonInteraction: '1',
            });
        }, 1000);
    }, []);

    return (
        <div>
            <div className={classes.contaniner}>
                <div className={classes.imageContainer}>
                    <ResponsiveImage
                        className={`${classes.image}`}
                        path={image.url}
                        alt={image.title}
                        params={{}}
                    />
                </div>
                <div className={classes.description}>
                    <div className={classes.heading}>{heading}</div>
                    <div
                        className={classes.messageWrapper}
                    >
                        <ReactMarkdown renderers={transformRenderer} source={copy} escapeHtml={false} />
                    </div>
                    <div
                        className={classes.options}
                        onClick={openModal}
                        onKeyDown={() => { }}
                        role="button"
                        tabIndex={-1}
                    >
                        View Options
                    </div>
                </div>
            </div>
        </div>
    );
};
AddonV2.propTypes = {
    classes: object.isRequired,
    openModal: func,
    copy: string.isRequired,
    heading: string.isRequired,
    image: shape({
        url: string.isRequired,
        title: string.isRequired,
    }).isRequired,
    selectedSku: shape({
        name: string,
    }),
    trackEvent: func.isRequired,
};

AddonV2.defaultProps = {
    openModal: () => { },
    selectedSku: {},
};
const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
});

const enhance = compose(
    connect(null, mapDispatchToProps),
    withStyles(styles),
);
export default enhance(AddonV2);
